import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import apiRequest from '../../../../../utils/apiRequest';
import { PRODUCTS_FAVORITES } from '../../../../../apis';
import { actionChangeDataFavoritePage } from '../../../../../redux/actions/favorites';
import { LazyLoadImage } from "react-lazy-load-image-component";
import FavListEmpty from '../../../../../styles/images/svg/favorites-list-empty.svg';
import CardFavoriteMobile from './cards/cardFavoriteMobile';
import CardFavoriteDesktop from './cards/cardFavoriteDesktop';



const FavList = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();


	const { isMobile } = useSelector(state => state.general);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { token } = useSelector(state => state.login);
	const { favList, products } = useSelector(state => state.favoriteList);

	

	useEffect(() => {
		if(favList.length > 0)
        	apiFavorites();
        else
        	dispatch(actionChangeDataFavoritePage('products', []));
    }, []);

    useEffect(() => {
    	if(favList.length > 0)
        	apiFavorites();
        else
        	dispatch(actionChangeDataFavoritePage('products', []));
    }, [favList]);



	const apiFavorites = () => {
		if(! isBackdropLoading) {

	  		let postData = { slugs: favList };

			apiRequest({
			    dispatch,
			    endpoint: PRODUCTS_FAVORITES ,
			    method: 'post',
			    data: postData,
			    token: token, 
			    onSuccess: (res) => {
			      	dispatch(actionChangeDataFavoritePage('products', res.products));
			    },
		  	});
		}
	};


    return (
    	<>

    	{isMobile ?
    	<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">
    		<div className="flex justify-between items-center lg:py-4 px-4">
    			<div className="break-words py-3 styles-ProfileCard-title-mobileHeader">
    				<div className="flex items-center grow">
    					<div className="flex shrink-0 ml-2 cursor-pointer" onClick={() => navigate(-1)} >
    						<ArrowForwardIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
    					</div>
    					<p className="grow text-h5 text-neutral-900 mb-0">
    						<span className="relative">لیست علاقه‌مندی‌ها</span>
    					</p>
    				</div>
    			</div>
    		</div>
    	</div>
    	:''}

    	<div className="lg:bg-neutral-000 lg:rounded-medium overflow-hidden lg:border-complete-200">

    		{! isMobile &&
			<div className="border-complete-b-200 mb-2 lg:mb-0">
				<div className="bg-neutral-000 flex items-center border-complete-b-200 px-3 py-4 lg:px-6 mb-2 lg:mb-0">
					
					<div className="grow text-h5 text-neutral-900 mr-2">لیست علاقه مندی ها
					</div>
				</div>
			</div>
			}

			<div>
				<ul>
					<li>
						<div className="flex flex-col justify-between px-4 mb-4">
							<div id="plpLayoutContainer" className="relative w-full flex flex-col lg:flex-row items-center lg:items-stretch justify-between styles_PLPLayout__D_okU">
								<section className="w-full grow relative">
								{ favList.length === 0 ?
									<div className="w-full flex items-center flex-col justify-center select-none py-20 user-select-none">
										<div className="mb-2 w-full flex justify-center">
											<div aria-hidden="false" aria-label="لیست علاقه‌مندی‌های شما خالی است." style={{width: "200px", height: "150px", lineHeight: "0"}}>
												<LazyLoadImage className="w-full inline-block" src={FavListEmpty} width="200" height="150" alt="لیست علاقه‌مندی‌های شما خالی است." title="" style={{objectFit: "contain"}} />
											</div>
										</div>
										<div className="text-body-1 text-neutral-900 mb-8">
											لیست علاقه‌مندی‌های شما خالی است.
										</div>
									</div>

									:

									<div className="flex h-full flex-col">
										<div id="11">
											<div className="flex flex-wrap">

												{
													products.map((product, key) => {
														if(isMobile) {
															return (
																<CardFavoriteMobile data={{product}} key={`fav-p-${key}`} />
															);
														} else {
															return (
																<CardFavoriteDesktop data={{product, key, isMobile}} key={`fav-p-${key}`} />
															);
														}
													})
												}
											</div>
										</div>
									</div>
								}
								</section>
							</div>
						</div>
					</li>
				</ul>
			</div>



		</div>


		</>
    );
}

export default FavList;